(function () {
  if (!/\/collections\//.test(window.location.pathname)) return;

  const MODULE_ID = "hue-single-review-module";
  const GRID_SELECTOR = ".product-grid";
  const CARD_SELECTOR = "product-block";

  const MOBILE_AFTER = 2;
  const DESKTOP_AFTER = 7;

  const HUE_BY_COLLECTION_PATH = {
    "/collections/lips": "half-magic-lips",
    "/collections/all-products": "half-magic-all",
    "/collections/eyes": "half-magic-eye",
    "/collections/face": "half-magic-face",
    "/collections/adornments": "half-magic-gems",
    "/collections/sets-kits": "half-magic-value-sets",
    "/collections/bestseller": "half-magic-bestseller-page",
  };

  function getHueProductId() {
    const path = (window.location.pathname || "").replace(/\/+$/, "");
    return HUE_BY_COLLECTION_PATH[path] || "half-magic-bestseller-page";
  }

  const isMobile = () => window.innerWidth <= 767;

  function getGrid() {
    return document.querySelector(GRID_SELECTOR);
  }

  function getCards(grid) {
    return grid ? Array.from(grid.querySelectorAll(CARD_SELECTOR)) : [];
  }

  function desiredAfterIndex() {
    return isMobile() ? MOBILE_AFTER : DESKTOP_AFTER;
  }

  // ---- "do not retry" logic when Hue unmounts due to no content ----
  let disabledForThisPage = false;
  let lastInsertAt = 0;

  // If Hue removes the mount within this window, assume "no content" and stop reinserting
  const UNMOUNT_GRACE_MS = 4000;

  function ensureModuleEl() {
    if (disabledForThisPage) return null;

    const productId = getHueProductId();
    let el = document.getElementById(MODULE_ID);

    if (!el) {
      el = document.createElement("div");
      el.id = MODULE_ID;
      el.className = "hue-module";
      el.dataset.productId = productId;
    } else {
      el.dataset.productId = productId;
    }

    return el;
  }

  function placeModule() {
    if (disabledForThisPage) return true;

    const grid = getGrid();
    if (!grid) return false;

    const cards = getCards(grid);
    if (cards.length === 0) return false;

    const moduleEl = ensureModuleEl();
    if (!moduleEl) return true;

    const idx = desiredAfterIndex();
    const afterEl = cards.length >= idx ? cards[idx - 1] : cards[cards.length - 1];

    // already correct
    if (moduleEl.parentNode === grid && moduleEl.previousSibling === afterEl) return true;

    afterEl.after(moduleEl);

    // mark time of insertion/move into grid (so we can detect quick unmount)
    lastInsertAt = Date.now();

    return true;
  }

  // Debounce
  let t = null;
  function schedulePlace() {
    if (disabledForThisPage) return;
    clearTimeout(t);
    t = setTimeout(placeModule, 120);
  }

  function retryInitial(maxTries, delayMs) {
    let tries = 0;
    (function tick() {
      tries += 1;
      if (placeModule()) return;
      if (tries >= maxTries) return;
      setTimeout(tick, delayMs);
    })();
  }

  function startObserver() {
    const root = document.documentElement;

    const mo = new MutationObserver(() => {
      if (disabledForThisPage) return;

      const grid = getGrid();
      if (!grid) return;

      const moduleEl = document.getElementById(MODULE_ID);
      const missing = !moduleEl;

      if (missing) {
        // If it disappeared soon after we inserted it, assume Hue removed it due to no content.
        if (lastInsertAt && Date.now() - lastInsertAt < UNMOUNT_GRACE_MS) {
          disabledForThisPage = true;
          return;
        }
        // Otherwise it's likely a filter/grid rerender: reinsert.
        schedulePlace();
        return;
      }

      // Module exists; keep it positioned after filter rerenders / card count changes.
      schedulePlace();
    });

    mo.observe(root, { childList: true, subtree: true });
  }

  let lastMobile = isMobile();
  window.addEventListener(
    "resize",
    () => {
      const nowMobile = isMobile();
      if (nowMobile !== lastMobile) {
        lastMobile = nowMobile;
        schedulePlace();
      }
    },
    { passive: true }
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      retryInitial(60, 100);
      startObserver();
    });
  } else {
    retryInitial(60, 100);
    startObserver();
  }

  document.addEventListener("hue-add-to-cart", (e) => {
    const variantId = e?.detail?.variantId;
    if (!variantId) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
  });
})();